import { render, staticRenderFns } from "./ia.vue?vue&type=template&id=83847664&scoped=true&"
import script from "./ia.vue?vue&type=script&lang=js&"
export * from "./ia.vue?vue&type=script&lang=js&"
import style0 from "./ia.vue?vue&type=style&index=0&id=83847664&prod&scoped=true&lang=css&"
import style1 from "./ia.vue?vue&type=style&index=1&id=83847664&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83847664",
  null
  
)

export default component.exports